export const toGraphQLQuery = (jsObject) => {
  return JSON.stringify(jsObject).replace(/"([^(")"]+)":/g,"$1:")
}